import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";

import authService from "../services/authservices";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { ScaleLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

import dayjs from "dayjs";

function SupportHistory() {
  const [supportHistory, setSupportHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPageSp, setCurrentPageSp] = useState(1);
  const [totalPagesSp, setTotalPagesSp] = useState(0);
  const [limitSp, setLimitSp] = useState(10);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    fetchSupportHistory(currentPageSp, limitSp);
  }, [currentPageSp, limitSp]);

  const fetchSupportHistory = async (page, limit) => {
    try {
      const response = await authService.getsupport(page, limit);
      if (response.status) {
        setSupportHistory(response.data);
        setTotalPagesSp(Math.ceil(response.total / limit));
        setLoading(false);
      } else {
        console.error("Failed to fetch support history");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching support history:", error);
      setLoading(false);
    }
  };
  const handlePageChangeSp = (event, value) => {
    setCurrentPageSp(value);
  };

  return (
    <div className="recent_depo_main">
      <div className="manage_btn_row">
        <span className="home_right_marketspan"> {t("SupportHistories")}</span>
        <Link to="/support">
          <div className="d-flex align-items-center gap-2 cursor-pointer">
            <span className="home_starty_view">{t("BackToSupport")}</span>
            <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
          </div>
        </Link>
      </div>
      <div className="recent_depo_tablemain pb-0">
        <div className="table-responsive table-borderless home_recent_table">
          {loading ? (
            <div className="loader_main loader_mainChange">
              <ScaleLoader color="#20A1FD" height={10} width={3} />
              <p>{t("Loading")}</p>
            </div>
          ) : (
            <>
              <table className="table">
                <thead>
                  <tr>
                    <th>{t("TicketID")}</th>
                    <th>{t("Date&Time")}</th>
                    <th>{t("Subject")}</th>
                    <th>{t("Category")}</th>
                    <th>{t("Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {supportHistory.length > 0 ? (
                    supportHistory.slice(0, 5).map((ticket) => (
                      <tr key={ticket._id}>
                        <td>
                          <span>{ticket._id}</span>
                        </td>
                        <td>
                          <span>{ticket.created_at}</span>
                        </td>
                        <td>
                          <span>{ticket.subject}</span>
                        </td>
                        <td>
                          <span>{ticket.category}</span>
                        </td>
                        <td>
                          <span>
                            {ticket.status === "0" ? "Open" : "Closed"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">{t("NoSupportTicketsFound")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {totalPagesSp > 1 && (
                <div className="pagination history_pagination_all">
                  <Stack spacing={2}>
                    <Pagination
                      count={totalPagesSp}
                      page={currentPageSp}
                      onChange={handlePageChangeSp}
                      size="small"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#fff",
                        },
                        "& .Mui-selected": {
                          backgroundColor: "#ffc630 !important",
                          color: "#000",
                          "&:hover": {
                            backgroundColor: "#ffc630",
                            color: "#000",
                          },
                        },
                        "& .MuiPaginationItem-ellipsis": {
                          color: "#fff",
                        },
                        "& .MuiPaginationItem-icon": {
                          color: "#fff",
                        },
                      }}
                    />
                  </Stack>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportHistory;
